import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Saferpay3DS from '../components/Saferpay3DS'
import { closeModal } from 'Rentlio/state/actions/ui'
import { modals } from 'Rentlio/screen/layout/utils/modalsEnum'

const Saferpay3DSContainer = props => {
  return props.activeModal === modals.SAFERPAY_3DS ? <Saferpay3DS {...props} /> : null
}

Saferpay3DSContainer.propTypes = {
  closeModal: PropTypes.func,
  activeModal: PropTypes.string
}

const mapStateToProps = state => ({
  activeModal: state.modals.openModal,
  modalData: state.modals.modalData
})

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(Saferpay3DSContainer)
